export const formatDate = (dateStr: string | number): string => {
  if (!dateStr) return '';
  
  const dateString = String(dateStr);
  
  // Function to pad single digits with leading zero
  const padWithZero = (str: string) => {
    return str.replace(/\b(\d)\b/g, '0$1');
  };
  
  // Normalize different date formats to DD-MM-YYYY consistently
  // Handle DD/MM/YYYY format - convert to DD-MM-YYYY
  if (dateString.includes('/')) {
    const normalized = dateString.replace(/\//g, '-');
    return padWithZero(normalized);
  }
  
  // Handle DD.MM.YYYY format - convert to DD-MM-YYYY  
  if (dateString.includes('.')) {
    const normalized = dateString.replace(/\./g, '-');
    return padWithZero(normalized);
  }
  
  // Already in DD-MM-YYYY format or other format, pad single digits
  return padWithZero(dateString);
};

// Helper to check if date is valid
function isValidDate(date: any): boolean {
  return date instanceof Date && !isNaN(date.getTime());
}

export const formatTime = (timeStr: string | number): string => {
  if (!timeStr) return '';

  // Return the time exactly as it comes from the database/Excel
  // No formatting, no conversion, just pass it through
  return String(timeStr);
};
